import { z } from 'zod/v3';
import {
  transformNullish,
  transformToValidPeriod,
} from '../../../common/utils';
import { AlgorithmJoinFormDataSchema } from '../joins/schema/formData/AlgorithmJoinFormDataSchema';
import {
  AlgorithmJoinFormDataType,
  AlgorithmJoinQueryDtoType,
} from '../joins/schema/types';

import { AlgorithmMappingQueryDtoSchema } from '../mappings/schema/AlgorithmMappingQueryDtoSchema';
import { AlgorithmSourceFormDataSchema } from '../sources/schema/AlgorithmSourceFormDataSchema';
import { AlgorithmTargetFormDataSchema } from '../targets/schema/AlgorithmTargetFormDataSchema';
import {
  AlgorithmSourceFormDataType,
  AlgorithmSourceQueryDtoType,
} from '../sources/schema/types';
import type { AlgorithmMappingQueryDtoType } from '../mappings/schema/types';
import { AlgorithmBasicBaseSchema } from './AlgorithmBasicSchema';
import { AlgorithmSourcesConfidentialityRuleFormDataSchema } from '../sources/schema/AlgorithmSourcesFormDataSchema';

const AlgorithmExtendedBaseSchema = AlgorithmBasicBaseSchema.extend({
  confidentialityRule:
    AlgorithmSourcesConfidentialityRuleFormDataSchema.nullish(),
  sources: transformNullish<
    AlgorithmSourceFormDataType[],
    AlgorithmSourceQueryDtoType[]
  >(AlgorithmSourceFormDataSchema.array(), []),
  mappings: transformNullish<
    AlgorithmMappingQueryDtoType[],
    AlgorithmMappingQueryDtoType[]
  >(AlgorithmMappingQueryDtoSchema.array(), []),
  joins: transformNullish<
    AlgorithmJoinFormDataType[],
    AlgorithmJoinQueryDtoType[]
  >(AlgorithmJoinFormDataSchema.array(), []),
  targets: transformNullish<
    z.output<typeof AlgorithmTargetFormDataSchema>[],
    z.input<typeof AlgorithmTargetFormDataSchema>[]
  >(AlgorithmTargetFormDataSchema.array(), []),
});

const transform = <T extends typeof AlgorithmExtendedBaseSchema.shape>(
  schemaVariant: z.ZodObject<T>,
) =>
  transformToValidPeriod(schemaVariant) // Workaround for known issue: https://github.com/colinhacks/zod/issues/2732
    .transform(
      (data) => data as Omit<typeof data, 'id'> & { readonly id: number },
    );

export const AlgorithmExtendedSchema = transform(AlgorithmExtendedBaseSchema);
